import React from 'react';
import styles from './DoughnutChart.module.scss';

interface DoughnutChartProps {
  completion: number;
  color: string;
  strokeColor?: string;
}

const DoughnutChart: React.FC<DoughnutChartProps> = ({
  completion,
  color,
  strokeColor,
}) => {
  const radius = 25;
  const stroke = 7;
  const normalizedRadius = radius - stroke / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (completion / 100) * circumference;

  return (
    <svg
      height={radius * 2}
      width={radius * 2}
      className={styles.doughnutChart}
    >
      <circle
        stroke={strokeColor ?? '#d3d3d3'}
        fill="transparent"
        strokeWidth={stroke}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <circle
        stroke={color}
        fill="transparent"
        strokeWidth={stroke}
        strokeDasharray={`${circumference} ${circumference}`}
        style={{ strokeDashoffset }}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
    </svg>
  );
};

export default DoughnutChart;
